import { useEffect } from "react";

export default function LegalLayout({ title, lastUpdated, children, testid }) {
  useEffect(() => {
    document.title = `${title} | Brand-in-a-Box`;
  }, [title]);

  return (
    <div data-testid={testid} className="bg-[#05060c] min-h-screen">
      <section className="relative pt-20 pb-10 md:pt-32 border-b border-white/[0.06] overflow-hidden">
        <div className="absolute inset-0 bg-aurora opacity-30" aria-hidden />
        <div className="relative max-w-3xl mx-auto px-6 lg:px-8">
          <span className="font-mono text-[11px] font-semibold tracking-widest uppercase text-cyan-400">
            Legal
          </span>
          <h1 className="mt-3 text-4xl sm:text-5xl md:text-6xl font-black tracking-tighter text-white leading-tight">
            {title}
          </h1>
          <p className="mt-4 text-sm text-slate-500">Last updated: {lastUpdated}</p>
        </div>
      </section>
      <section className="py-16">
        <article className="prose prose-invert max-w-3xl mx-auto px-6 lg:px-8 prose-headings:tracking-tight prose-h2:text-2xl prose-h2:font-extrabold prose-h2:text-white prose-h2:mt-10 prose-h2:mb-3 prose-h3:text-lg prose-h3:font-bold prose-h3:text-white prose-p:text-slate-400 prose-p:leading-relaxed prose-li:text-slate-400 prose-strong:text-slate-200 prose-a:text-cyan-300 hover:prose-a:text-cyan-200">
          {children}
        </article>
      </section>
    </div>
  );
}
